import Grades from './FeedbackGrades';
import Sounds from './FeedbackSounds';

export default { Grades, Sounds };
